import { useMemo, useState } from 'react';
import type { SortOrder } from 'antd/es/table/interface';

import type { MadeColumnType } from '../hooks/useMakeColumns';

export interface LocalSortState {
    columnKey: string;
    order: SortOrder;
}

interface UseLocalSortProps {
    dataSource: readonly any[];
    columns: MadeColumnType[];
}

export function useLocalSort({ dataSource, columns }: UseLocalSortProps) {
    const [localSort, setLocalSort] = useState<LocalSortState | null>(null);

    const sortedDataSource = useMemo(() => {
        const col = localSort ? columns.find(c => String(c.key) === localSort.columnKey) : null;
        const sorter = typeof col?.sorter === 'function' ? col.sorter : null;
        const shouldNotSort = !localSort || !sorter;

        if (shouldNotSort) {
            return dataSource;
        } else {
            const direction = localSort.order === 'descend' ? -1 : 1;
            return [...dataSource].sort((a, b) => direction * sorter(a, b));
        }
    }, [dataSource, localSort, columns]);

    return { localSort, setLocalSort, sortedDataSource };
}
